import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useCallback } from "react";

/**
 * Returns a function that produces a reCAPTCHA v3 token for a given action.
 * Usage:
 *   const getToken = useRecaptchaToken();
 *   const token = await getToken("contact_form");
 */
export const useRecaptchaToken = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return useCallback(
    async (action = "submit") => {
      if (!executeRecaptcha) return null;
      try {
        return await executeRecaptcha(action);
      } catch (e) {
        console.error("reCAPTCHA error:", e);
        return null;
      }
    },
    [executeRecaptcha]
  );
};
